import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUserPasskeysAPI } from '../API/services';

export const fetchUserPasskeys = createAsyncThunk(
  'user/fetchUserPasskeys',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUserPasskeysAPI({}, {});

      if (response.status !== 200) {
        return rejectWithValue('Failed to fetch user passkeys');
      }

      const passkeys = response.data?.data?.passkeys || [];
      return passkeys;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
